import { appInfo } from '@/mocks/baoliao';

export default function AppEntry() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-background-50 rounded-lg border border-background-200/70 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              {appInfo.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appInfo.description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appInfo.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-md hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-google-play-fill text-lg"></i>
                Google Play 下载
              </button>
            </div>
          </div>

          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="relative w-full aspect-[9/16] max-w-[200px] mx-auto rounded-lg overflow-hidden bg-background-200 border-4 border-foreground-900/10">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20news%20app%20interface%20mockup%20with%20breaking%20news%20headlines%2C%20warm%20crimson%20red%20and%20cream%20color%20scheme%2C%20modern%20clean%20minimal%20design%2C%20dark%20mode%20theme%2C%20card%20based%20layout%2C%20scrolling%20feed%20with%20trending%20indicators%2C%20editorial%20app%20UI%20aesthetic&width=400&height=710&seq=app-mockup&orientation=portrait"
                alt="爆料专区移动客户端界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}